(function(){
  var c=window.vatConfig||{vatRate:0.25,defaultMode:"excl",moneyFormat:"{{amount_no_decimals}} kr"};
  var K="vat_display_mode";
  function gM(){return localStorage.getItem(K)||c.defaultMode;}
  function sM(m){localStorage.setItem(K,m);}
  function fM(cents){
    var a=(cents/100).toFixed(2);
    var nd=Math.round(cents/100);
    var ac=a.replace(".",",");
    var s=c.moneyFormat;
    s=s.replace("{{amount_with_comma_separator}}",ac.replace(/\d(?=(\d{3})+,)/g,"$& "));
    s=s.replace("{{amount_no_decimals_with_comma_separator}}",String(nd).replace(/\d(?=(\d{3})+$)/g,"$& "));
    s=s.replace("{{amount_no_decimals}}",String(nd).replace(/\d(?=(\d{3})+$)/g,"$& "));
    s=s.replace("{{amount}}",a.replace(/\d(?=(\d{3})+\.)/g,"$& "));
    return s;
  }
  function run(){
    var m=gM(),r=c.vatRate;
    var els=document.querySelectorAll(".vat-adjusted[data-price-base]");
    for(var i=0;i<els.length;i++){
      var b=parseInt(els[i].getAttribute("data-price-base"),10);
      if(isNaN(b))continue;
      var p=m==="incl"?Math.round(b*(1+r)):b;
      els[i].textContent=fM(p);
    }
        var notes=document.querySelectorAll("[data-vat-note]");for(var k=0;k<notes.length;k++){notes[k].textContent=m==="incl"?"Inkl. moms":"Exkl. moms";}
    var btns=document.querySelectorAll("[data-vat-toggle]");
    var t=document.getElementById("vat-toggle");
    if(t) t.setAttribute("data-mode", m);
    for(var j=0;j<btns.length;j++){
      var act=btns[j].getAttribute("data-vat-toggle")===m;
      btns[j].setAttribute("aria-pressed",act?"true":"false");
      if(act)btns[j].classList.add("vat-toggle__btn--active");
      else btns[j].classList.remove("vat-toggle__btn--active");
    }
  }
  function init(){
    var t=document.getElementById("vat-toggle");
    if(!t)return;
    t.addEventListener("click",function(e){
      var b=e.target.closest("[data-vat-toggle]");
      if(!b)return;
      sM(b.getAttribute("data-vat-toggle"));
      run();
    });
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){init();run();});
  }else{init();run();}
  document.addEventListener("cart:updated",function(){run();});
  document.addEventListener("cart:change",function(){run();});
  window.vatToggle={recalcPrices:run,getMode:gM,setMode:sM};
})();